import { createSlice } from "@reduxjs/toolkit";

// Function to get initial auth state from localStorage
const getInitialAuthState = () => {
  const savedUser = localStorage.getItem("user");
  const authToken = localStorage.getItem("auth_token");

  if (savedUser && authToken) {
    try {
      const user = JSON.parse(savedUser);
      console.log("Auth initialized from localStorage:", user.email);
      return {
        user,
        isAuthenticated: true,
        loading: false,
      };
    } catch (error) {
      console.error("Error parsing saved user:", error);
      localStorage.removeItem("user");
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_data");
    }
  }

  console.log("No saved user found, user needs to login");
  return {
    user: null,
    isAuthenticated: false,
    loading: false,
  };
};

const authSlice = createSlice({
  name: "auth",
  initialState: getInitialAuthState(),
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
      state.loading = false;

      if (action.payload) {
        localStorage.setItem("user", JSON.stringify(action.payload));
      } else {
        localStorage.removeItem("user");
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    loginSuccess: (state, action) => {
      const { user, token } = action.payload;
      state.user = user;
      state.isAuthenticated = true;
      state.loading = false;

      // Save to localStorage
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("auth_token", token);
      localStorage.setItem(
        "auth_data",
        JSON.stringify({
          user,
          token,
          timestamp: Date.now(),
        })
      );
    },
    logoutSuccess: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;

      // Clear localStorage
      localStorage.removeItem("user");
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_data");
    },
  },
});

export const { setUser, setLoading, loginSuccess, logoutSuccess } =
  authSlice.actions;

// Selectors
export const selectAuth = (state) => state.auth;
export const selectUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthLoading = (state) => state.auth.loading;

export default authSlice.reducer;
